import {ComponentType} from 'react';
import {Route} from 'react-router-dom';

import dynamic, {Loader} from 'next/dynamic';

import {clientRoutes} from '@/constants';
import {LoaderPage} from '@/ui/pages/LoaderPage/LoaderPage';

import {AuthGuard} from './ui/common/AuthGuard/AuthGuard';

// lazy-components
const MainPage = getDynamicComponent(() => import('@/ui/pages/MainPage/MainPage'), false);
const InvitePage = getDynamicComponent(() => import('@/ui/pages/InvitePage/InvitePage'), false);
const AuthPage = getDynamicComponent(() => import('@/ui/pages/AuthPage/User/AuthPageUser'));
const ClickerGamePage = getDynamicComponent(() => import('@/ui/pages/ClickerGamePage/ClickerGamePage'), true);
const ResultsPage = getDynamicComponent(() => import('@/ui/pages/ResultsPage/ResultsPage'), true);

const TestLinkPage = getDynamicComponent(() => import('@/ui/pages/TestLinkPage/TestLinkPage'));
const TestEnergyBattery = getDynamicComponent(() => import('@/ui/pages/TestEnergyBattery/TestEnergyBattery'));

export function getDynamicComponent(loader: Loader, showTabletBorders?: boolean): ComponentType {
  return dynamic({
    loader,
    loading: () => <LoaderPage showTabletBorders={showTabletBorders} />,
    ssr: false,
  });
}

function getComponentWithAuthGuard(Component: ComponentType): JSX.Element {
  return (
    <AuthGuard>
      <Component />
    </AuthGuard>
  );
}

export const routes = {
  stage: (
    <Route>
      <Route path={clientRoutes.Main} element={<MainPage />} />
      <Route path={clientRoutes.AuthUser} element={<AuthPage />} />
      <Route path={clientRoutes.ClickerGame} element={getComponentWithAuthGuard(ClickerGamePage)} />
      <Route path={clientRoutes.InvitePage} element={<InvitePage />} />
      <Route path={clientRoutes.TestLinks} element={<TestLinkPage />} />
      <Route path={clientRoutes.Results} element={getComponentWithAuthGuard(ResultsPage)} />

      <Route path={clientRoutes.TestEnergyBattery} element={<TestEnergyBattery />} />
    </Route>
  ),
  prod: (
    <Route>
      <Route path={clientRoutes.Main} element={<MainPage />} />
      <Route path={clientRoutes.AuthUser} element={<AuthPage />} />
      <Route path={clientRoutes.ClickerGame} element={getComponentWithAuthGuard(ClickerGamePage)} />
      <Route path={clientRoutes.Results} element={getComponentWithAuthGuard(ResultsPage)} />
      <Route path={clientRoutes.InvitePage} element={<InvitePage />} />
    </Route>
  ),
} as const;
